/* Copyright (c) Trimble Inc. All rights reserved. */
import { Button } from "@material-ui/core";
import { useDialogProps } from "legacy-components/dialog/Dialog";
import { getTeamDetails, setTeamDetails } from "libs/utils/storage/teamDetailsStorage";
import { useRole } from "libs/security/authorization/Permission";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import TeamServices from "pages/home/team/TeamService";
import { TeamJoiner } from "pages/home/teams/TeamJoiner";
import { TeamListViewer } from "pages/home/teams/TeamListViewer";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import * as actions from "../../../store/actions/actions";
export interface IAssociateTeamProps {
  toggleSubscriptionDialog ?: ()=> void
  subscriptionDialogOpen?: boolean
  state : any
  subscribe : any
}
export const AssociateTeam:React.FC<IAssociateTeamProps>= ({toggleSubscriptionDialog, subscriptionDialogOpen,
   state, subscribe}) => {
  // const teamClasses = useTeamStyles();
  const dispatch = useDispatch();
  const [, userRoleState, changeTeam] = useRole();

  useEffect(() => {
    const storedTeamId = getTeamDetails(userRoleState?.value?.uuid)?.teamId;
    if (storedTeamId != null) {
      changeTeam(storedTeamId);
      dispatch({
        type: actions.storeTeamDetails,
        payload: { currentTeam: storedTeamId },
      });
    }
  }, [dispatch, changeTeam, userRoleState?.value?.uuid]);

  const [selectedTeamName, setSelectedTeamName] = useState<string>(
    getTeamDetails(userRoleState?.value?.uuid)?.teamName ?? "Select a Team"
  );

  const [isLoading, toggleLoading] = useState<boolean>(false);

  const { open: selectOpen, toggle: selectToggle } = useDialogProps();

  const { open: joinOpen, toggle: joinToggle } = useDialogProps();

  const onClick = () => {
    selectToggle();
  };
  const history = useHistory();

  const handleChangeNew = (team: any) => {
    toggleLoading(!isLoading);
    changeTeam(team?.id as string);
    setTeamDetails(userRoleState?.value?.uuid, {
      teamId: team?.id as string,
      teamName: team?.teamName as string,
    });

    dispatch({
      type: actions.storeTeamDetails,
      payload: { currentTeam: team },
    });
    dispatch(history.push("/home"));

    return true;
  };

  useEffect(() => {
    toggleLoading(!isLoading);
  }, [userRoleState?.value?.teamId]);

  const [data, setData] = useState<Array<any | null>>([]);

  useEffect(() => {
    if (state?.value && state?.loaded) {
      const values = state?.value?.values;
      setData(values);
    }
  }, [state?.value , state?.loaded]);

  const { state: availableTeamsState, subscribe: availableTeamsSubscribe } = useAsyncAction(() =>
    TeamServices.getAvailableTeamsForUser()
  );

  const { state: accountsState, subscribe: accountsSubscribe } = useAsyncAction(() =>
    TeamServices.getUserAccounts(userRoleState?.value?.uuid as string)
  );


  const getAvailableTeams = () => {
    availableTeamsSubscribe();
    accountsSubscribe();
    if (!joinOpen) {
      joinToggle()
    }
  }
   
    return (
      <>
      
         <Button color="primary" variant="contained" 
         onClick={data?.length > 0 ? onClick : getAvailableTeams}
         >Join a Team
         </Button>
      
      {data?.length >= 1 && state?.loaded &&(
                  <TeamListViewer
                    selectOpen={selectOpen}
                    selectToggle={selectToggle}
                    joinOpen={joinOpen}
                    joinToggle={joinToggle}
                    data={data}
                    setSelectedTeamName={setSelectedTeamName}
                    handleChangeNew={handleChangeNew}
                    selectedTeamName={selectedTeamName}
                    refreshUserTeams={subscribe}
                    userUuid={userRoleState?.value?.uuid as string}
                    getAvailableTeams={getAvailableTeams} availableTeamsState={availableTeamsState}
                    toggleSubscriptionDialog={toggleSubscriptionDialog} 
                    subscriptionDialogOpen={subscriptionDialogOpen}
                    newUser={true}
                    accountsState={accountsState}/>
                )}
                {data?.length == 0 && state?.loaded && (
                  <TeamJoiner refreshUserTeams={subscribe} userUuid={userRoleState?.value?.uuid as string}
                    getAvailableTeams={getAvailableTeams} state={availableTeamsState} teamList={data} open={joinOpen} toggle={joinToggle}
                    toggleSubscriptionDialog={toggleSubscriptionDialog} 
                    subscriptionDialogOpen={subscriptionDialogOpen} newUser={true}
                    accountsState={accountsState}/>
      
                )}
                </>
    )
};

export default AssociateTeam;
